module.exports = __webpack_public_path__ + "files/SPIADI2021 - Rapport OBSERVA4 provisoire - février 2022.078709fbe287e0d6971fa815138aeb81.pdf";